(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', (e) => {
  const drawer = document.getElementById('menu-drawer');
  const search = document.getElementById('search-dialog');
  if (e.target.closest('[data-menu-toggle]') && drawer) drawer.showModal();
  else if (e.target.closest('[data-open-search]') && search) { search.showModal(); search.querySelector('input[name="q"]').focus(); }
  else if (e.target.closest('[data-menu-close]')) e.target.closest('dialog').close();
  else if (e.target === drawer || e.target === search) e.target.close();
  else if (e.target.closest('#cart-toggle')) document.dispatchEvent(new CustomEvent('dine:cart:open'));
});
if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="q"]');
      this.results = this.querySelector('[data-predictive-results]');
      let t;
      this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.search(), 250); });
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      this.abort && this.abort.abort();
      this.abort = new AbortController();
      try {
        const url = `${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,query&resources[limit]=6&section_id=predictive-search`;
        const html = await (await fetch(url, { signal: this.abort.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-predictive-results]');
        this.results.innerHTML = fresh ? fresh.innerHTML : '';
        this.input.setAttribute('aria-expanded', 'true');
      } catch (e) { if (e.name !== 'AbortError') this.results.innerHTML = ''; }
    }
  });
}
(() => {
  let openT, closeT, current = null, skipFocusOpen = false;
  const pill = (h) => document.querySelector(`.site-header__rayons a[data-rayon="${h}"]`);
  const open = (h) => {
    clearTimeout(closeT);
    if (current === h) return;
    close(true);
    const m = document.querySelector(`.mega[data-mega="${h}"]`);
    if (!m) return;
    current = h; m.hidden = false; requestAnimationFrame(() => m.classList.add('is-open'));
    pill(h).setAttribute('aria-expanded', 'true');
  };
  const close = (now) => {
    if (!current) return;
    const m = document.querySelector(`.mega[data-mega="${current}"]`);
    pill(current).setAttribute('aria-expanded', 'false');
    m.classList.remove('is-open');
    const done = () => { m.hidden = true; };
    now ? done() : setTimeout(done, 180);
    current = null;
  };
  document.addEventListener('pointerover', (e) => {
    const a = e.target.closest('.site-header__rayons a[aria-haspopup]');
    if (a && e.pointerType === 'mouse') { clearTimeout(openT); openT = setTimeout(() => open(a.dataset.rayon), 120); }
    else if (e.target.closest('.mega')) clearTimeout(closeT);
  });
  document.addEventListener('pointerout', (e) => {
    if (e.target.closest('.site-header__rayons, .mega') && !e.relatedTarget?.closest?.('.site-header__rayons, .mega')) {
      clearTimeout(openT); closeT = setTimeout(() => close(), 250);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && current) { const h = current; close(true); skipFocusOpen = true; pill(h).focus(); return; }
    const a = e.target.closest('.site-header__rayons a[aria-haspopup]');
    if (a && e.key === 'ArrowDown') { e.preventDefault(); open(a.dataset.rayon); document.querySelector(`.mega[data-mega="${a.dataset.rayon}"] .menu-tile`)?.focus(); }
    if (e.target.closest('.site-header__rayons') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      const all = [...document.querySelectorAll('.site-header__rayons a')];
      const i = all.indexOf(document.activeElement) + (e.key === 'ArrowRight' ? 1 : -1);
      all[(i + all.length) % all.length].focus(); e.preventDefault();
    }
  });
  document.addEventListener('focusout', (e) => {
    if (current && !e.relatedTarget?.closest?.('.site-header__rayons, .mega')) close();
  });
  // Clavier : le focus sur une pastille ouvre son panneau ; Tab entre dans les tuiles puis ressort vers la pastille suivante
  document.addEventListener('focusin', (e) => {
    const a = e.target.closest('.site-header__rayons a');
    if (!a) return;
    if (skipFocusOpen) { skipFocusOpen = false; return; }  // focus rendu par Échap : le panneau reste fermé
    if (a.hasAttribute('aria-haspopup')) { clearTimeout(openT); open(a.dataset.rayon); } else close(true);
  });
  const items = (m) => [...m.querySelectorAll('.menu-tile, .mega__encart')];
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !current) return;
    const m = document.querySelector(`.mega[data-mega="${current}"]`);
    const list = items(m), p = pill(current);
    const pills = [...document.querySelectorAll('.site-header__rayons a')];
    if (!e.shiftKey && document.activeElement === p && list.length) { e.preventDefault(); list[0].focus(); }
    else if (!e.shiftKey && document.activeElement === list[list.length - 1]) {
      e.preventDefault(); const nxt = pills[pills.indexOf(p) + 1]; close(true); (nxt || p).focus();
    } else if (e.shiftKey && document.activeElement === list[0]) { e.preventDefault(); p.focus(); }
  });
})();
document.addEventListener('click', (e) => {
  const go = e.target.closest('[data-drawer-go]');
  const back = e.target.closest('[data-drawer-back]');
  if (!go && !back) return;
  e.preventDefault();
  const drawer = document.getElementById('menu-drawer');
  const target = go ? drawer.querySelector(`[data-panel="${go.dataset.drawerGo}"]`) : drawer.querySelector('[data-level="0"]');
  if (!target) return;
  drawer.querySelectorAll('.drawer__panel').forEach((p) => { p.classList.toggle('is-active', p === target); p.hidden = p !== target; });
  (target.querySelector('.drawer__back, .menu-tile') || target).focus();
});
document.getElementById('menu-drawer')?.addEventListener('close', (e) => {
  e.target.querySelectorAll('.drawer__panel').forEach((p) => { const top = p.dataset.level === '0'; p.classList.toggle('is-active', top); p.hidden = !top; });
});
(() => {
  // Bas visible de l'en-tête (bandeau d'annonce compris tant qu'il est à l'écran) : les barres collantes se placent dessous
  const setH = () => { const h = document.querySelector('.site-header'); if (h) document.documentElement.style.setProperty('--header-h', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px'); };
  setH(); addEventListener('resize', setH); document.addEventListener('dine:scroll', setH); addEventListener('load', setH);
})();
(() => {
  // Hauteur du bandeau d'annonce : sur l'accueil, l'en-tête transparent se place juste dessous
  const setA = () => { const a = document.querySelector('.announcement'); document.documentElement.style.setProperty('--announce-h', (a ? a.offsetHeight : 0) + 'px'); };
  setA(); addEventListener('resize', setA);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = () => document.querySelectorAll('[data-hero]').forEach((hero) => {
    const mobile = matchMedia('(max-width: 700px)').matches;
    const v = hero.querySelector(mobile ? '.hero__video--mobile' : '.hero__video--desktop');
    if (!v || !window.Dine) return;
    window.Dine.loadVideo(v);
    v.playbackRate = 0.85;
    if (!window.Dine.reducedMotion) v.play().catch(() => {});
  });
  if (document.readyState === 'complete') start(); else addEventListener('load', start, { once: true });
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('look-book')) {
  customElements.define('look-book', class extends HTMLElement {
    connectedCallback() {
      this.imgs = [...this.querySelectorAll('.lookbook__img')];
      this.sw = [...this.querySelectorAll('.lookbook__swatch')];
      if (!this.sw.length) return;
      this.auto = !(window.Dine && window.Dine.reducedMotion);
      this.show(0);
      this.sw.forEach((b, k) => b.addEventListener('click', () => { this.stop(); this.show(k); }));
      this.querySelector('[data-lookbook-add]').addEventListener('click', (e) => {
        const b = e.currentTarget;
        if (window.Dine && window.Dine.cart) window.Dine.cart.add(b.dataset.variant, 1, this.imgs[this.i]);
      });
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => this.start());
      this.start();
    }
    disconnectedCallback() { clearInterval(this.timer); }
    start() { clearInterval(this.timer); if (this.auto) this.timer = setInterval(() => this.show((this.i + 1) % this.sw.length), 3000); }
    stop() { this.auto = false; clearInterval(this.timer); }
    show(k) {
      this.i = k;
      const b = this.sw[k];
      this.imgs.forEach((im, j) => { im.classList.toggle('is-on', j === k); if (j === k) im.loading = 'eager'; });
      this.sw.forEach((s, j) => s.setAttribute('aria-pressed', String(j === k)));
      this.querySelector('.lookbook__name').textContent = b.getAttribute('aria-label');
      this.querySelector('.lookbook__price').textContent = b.dataset.price;
      const add = this.querySelector('[data-lookbook-add]');
      add.dataset.variant = b.dataset.variant;
      add.disabled = b.dataset.available !== 'true';
      this.querySelector('.lookbook__more').href = b.dataset.url;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('main-collection')) {
  customElements.define('main-collection', class extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('[data-filters]');
      if (form) form.addEventListener('submit', () => {
        form.querySelectorAll('input, select').forEach((i) => { if (i.name && i.value === '') i.disabled = true; });
      });
      this.addEventListener('click', async (e) => {
        const more = e.target.closest('[data-load-more]');
        if (!more) return;
        e.preventDefault();
        if (more.dataset.loading) return;
        more.dataset.loading = '1';
        try {
          const url = new URL(more.href, location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          const html = await (await fetch(url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = this.querySelector('.coll__grid');
          doc.querySelectorAll('.coll__grid > *').forEach((c) => grid.appendChild(c));
          const next = doc.querySelector('[data-load-more]');
          if (next) { more.href = next.getAttribute('href'); delete more.dataset.loading; } else more.closest('.coll__more').remove();
          if (window.Dine) window.Dine.scan(grid);
        } catch (err) { location.href = more.href; }
      });
    }
  });
}
(() => {
  const place = () => document.querySelectorAll('main-collection').forEach((root) => {
    const dlg = root.querySelector('#filters'), home = root.querySelector('[data-filters-home]');
    if (!dlg || !home) return;
    const wide = matchMedia('(min-width: 990px)').matches;
    const items = wide ? [...dlg.querySelectorAll(':scope > .coll__filter, :scope > .coll__clear')] : [...home.children];
    if (items.length) (wide ? home : dlg).append(...items);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  matchMedia('(min-width: 990px)').addEventListener('change', place);
  document.addEventListener('shopify:section:load', place);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('main-product')) {
  customElements.define('main-product', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-product-form]');
      const json = this.querySelector('[data-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      const initial = [...this.querySelectorAll('.pdp__option')].map((f) => (f.querySelector('input:checked') || {}).value);
      if (initial.length) this.filterByColor(initial, { scroll: false });
      this.addEventListener('change', (e) => {
        if (!e.target.matches('.pdp__option input[type="radio"]')) return;
        const values = [...this.querySelectorAll('.pdp__option')].map((f) => (f.querySelector('input:checked') || {}).value);
        this.selectOptions(values);
      });
      this.addEventListener('click', (e) => {
        const step = e.target.closest('[data-qty-step]');
        if (step) {
          const input = this.querySelector('input[name="quantity"]');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep));
        }
        const thumb = e.target.closest('[data-thumb]');
        if (thumb) this.showMedia(thumb.dataset.thumb);
      });
      if (this.form) this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        const id = this.form.querySelector('[data-variant-id]').value;
        const qty = parseInt(this.form.querySelector('input[name="quantity"]').value, 10) || 1;
        const btn = this.form.querySelector('[data-add]');
        if (btn.disabled) return;
        window.Dine.cart.add(id, qty, this.querySelector('.pdp__slide img'));
      });
      const ship = this.querySelector('[data-ship]');
      if (ship && window.Dine.shipText) ship.textContent = window.Dine.shipText(new Date(), Number(ship.dataset.cutoff || 14), ship.dataset.tToday, ship.dataset.tLater);
      const sticky = this.querySelector('.pdp-sticky');
      const main = this.querySelector('[data-add]');
      if (sticky && main) {
        new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(main);
        sticky.querySelector('[data-sticky-add]').addEventListener('click', () => this.form.requestSubmit());
      }
      this.addEventListener('variant:change', (e) => {
        const low = this.querySelector('[data-low-stock]');
        const q = e.detail.qty;
        const threshold = Number(this.dataset.lowStock || 3);
        low.hidden = !(q !== null && q > 0 && q <= threshold);
        if (!low.hidden) low.textContent = (this.dataset.tLow || '').replace('{n}', q);
        this.querySelectorAll('.pdp-sticky [data-price]').forEach((p) => { p.textContent = this.money(e.detail.price); });
      });
    }
    money(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }
    selectOptions(values) {
      const v = this.variants.find((x) => x.options.every((o, i) => o === values[i]));
      const add = this.querySelector('[data-add]');
      const label = this.querySelector('[data-add-label]');
      this.querySelectorAll('[data-option-value]').forEach((s, i) => { s.textContent = values[i] || ''; });
      const sticky = this.querySelector('[data-sticky-add]');
      if (!v) {
        add.disabled = true; label.textContent = this.dataset.tUnavailable || 'Indisponible';
        if (sticky) { sticky.disabled = true; sticky.textContent = label.textContent; }
        const low = this.querySelector('[data-low-stock]'); if (low) low.hidden = true;
        return;
      }
      this.querySelector('[data-variant-id]').value = v.id;
      this.querySelector('[data-price]').textContent = this.money(v.price);
      const cmp = this.querySelector('[data-compare]');
      cmp.hidden = !(v.compare_at_price && v.compare_at_price > v.price);
      if (!cmp.hidden) cmp.textContent = this.money(v.compare_at_price);
      add.disabled = !v.available;
      label.textContent = v.available ? (this.dataset.tAdd || 'Ajouter au panier') : (this.dataset.tSoldOut || 'Épuisé');
      if (sticky) { sticky.disabled = !v.available; sticky.textContent = label.textContent; }
      this.dispatchEvent(new CustomEvent('variant:change', { detail: v, bubbles: true }));
      this.filterByColor(values);
      if (v.media_id) { const s = this.querySelector(`[data-media-id="${v.media_id}"]`); if (s && !s.hidden) this.showMedia(v.media_id); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    normColor(s) {
      return (s || '').normalize('NFKD').replace(/[\u0300-\u036f’']/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    filterByColor(values, { scroll = true } = {}) {
      const colorField = [...this.querySelectorAll('.pdp__option')].find((f) => f.querySelector('.swatch'));
      if (!colorField) return;
      const idx = Number(colorField.dataset.optionIndex);
      const key = this.normColor(values[idx]);
      const tagged = this.querySelectorAll('[data-color]');
      if (!tagged.length) return;
      let first = null;
      this.querySelectorAll('.pdp__slide, .pdp__thumb').forEach((el) => {
        const c = el.dataset.color;
        const show = !c || c === key;
        el.hidden = !show;
        if (show && !first && el.classList.contains('pdp__slide')) first = el;
      });
      if (first) this.showMedia(first.dataset.mediaId, scroll);
    }
    showMedia(id, scroll = true) {
      const slide = this.querySelector(`[data-media-id="${id}"]`);
      if (!slide) return;
      this.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
      if (scroll) slide.scrollIntoView({ behavior: window.Dine && window.Dine.reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-collections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pinned-collections')) {
  customElements.define('pinned-collections', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.pinned__list li')];
      this.layers = [...this.querySelectorAll('.pinned__layer')];
      this.current = -1;
      this.desktop = matchMedia('(min-width: 801px)');
      this.onScroll = () => this.update();
      document.addEventListener('dine:scroll', this.onScroll);
      addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() { document.removeEventListener('dine:scroll', this.onScroll); removeEventListener('scroll', this.onScroll); }
    update() {
      const n = this.items.length;
      if (!n) return;
      if (!this.desktop.matches || (window.Dine && window.Dine.reducedMotion)) { this.layers.forEach((l) => l.classList.add('is-active')); return; }
      const r = this.getBoundingClientRect();
      const total = this.offsetHeight - innerHeight;
      const p = Math.min(Math.max(-r.top / total, 0), 0.999);
      this.set(Math.floor(p * n));
    }
    set(i) {
      if (i === this.current) return;
      this.current = i;
      this.items.forEach((li, k) => li.classList.toggle('is-active', k === i));
      this.layers.forEach((l, k) => {
        const v = l.querySelector('video');
        l.classList.toggle('is-active', k === i);
        if (!v || !window.Dine) return;
        if (k === i) { window.Dine.loadVideo(v); v.play().catch(() => {}); } else v.pause();
      });
      const c = this.querySelector('[data-pinned-current]');
      if (c) c.textContent = String(i + 1).padStart(2, '0');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.rail-tabs [role="tab"]');
    if (!tab) return;
    const root = tab.closest('.product-rail');
    root.querySelectorAll('[role="tab"]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    root.querySelectorAll('.rail__panel').forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); if (!p.hidden) p.classList.add('is-in'); });
  });
  let drag = null;
  document.addEventListener('pointerdown', (e) => {
    const rail = e.target.closest('.rail');
    if (!rail || e.pointerType !== 'mouse') return;
    drag = { rail, x: e.clientX, s: rail.scrollLeft, moved: false };
  });
  addEventListener('pointermove', (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.x;
    if (Math.abs(dx) > 5) { drag.moved = true; drag.rail.classList.add('is-dragging'); }
    drag.rail.scrollLeft = drag.s - dx;
  });
  document.addEventListener('dragstart', (e) => { if (e.target.closest('.rail')) e.preventDefault(); });
  const end = () => {
    if (!drag) return;
    const { rail, moved } = drag;
    rail.classList.remove('is-dragging');
    if (moved) rail.addEventListener('click', (ev) => ev.preventDefault(), { capture: true, once: true });
    drag = null;
  };
  addEventListener('pointerup', end);
  addEventListener('pointercancel', end);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-card]')) return;
      new IntersectionObserver(async (entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) { this.innerHTML = fresh.innerHTML; if (window.Dine) window.Dine.scan(this); }
        } catch (e) { /* section facultative */ }
      }, { rootMargin: '400px 0px' }).observe(this);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseaux-integres"] && !Shopify.designMode) return;
  try {
    
(() => {
  const load = (src) => { if (!document.querySelector(`script[src="${src}"]`)) { const s = document.createElement('script'); s.src = src; s.async = true; document.body.appendChild(s); } };
  const start = (root) => {
    if (root.hidden) return;
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      if (root.dataset.tiktok === 'true') load('https://www.tiktok.com/embed.js');
      if (root.dataset.snap === 'true') load('https://www.snapchat.com/embed.js');
    }, { rootMargin: '300px 0px' });
    io.observe(root);
  };
  const scan = () => document.querySelectorAll('[data-reseaux]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', (e) => {
    const look = e.target.closest('.look');
    if (!look) return;
    const spot = e.target.closest('.look__spot');
    const pop = look.querySelector('.look__pop');
    if (spot) {
      const i = spot.dataset.spot;
      const item = look.querySelector(`.look__item[data-spot="${i}"]`);
      look.querySelectorAll('.look__item').forEach((l) => l.classList.toggle('is-active', l === item));
      if (item) {
        pop.replaceChildren(...[...item.children].filter((c) => !c.classList.contains('look__num')).map((c) => c.cloneNode(true)));
        pop.classList.add('is-open');
      }
      return;
    }
    if (e.target.closest('.look__all')) {
      const ids = [...look.querySelectorAll('.look__item [data-quick-add]')].map((b) => b.dataset.quickAdd);
      if (ids.length) window.Dine.cart.addMany(ids, look.querySelector('.look__item'));
      return;
    }
    if (e.target.closest('.look__media') && !e.target.closest('.look__pop')) {
      pop.classList.remove('is-open');
      look.querySelectorAll('.look__item').forEach((l) => l.classList.remove('is-active'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["univers"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cache = new Map();
  document.addEventListener('click', async (e) => {
    const tab = e.target.closest('.univers__tab');
    if (!tab) return;
    const root = tab.closest('[data-univers]');
    const panel = root.querySelector('.univers__panel');
    root.querySelectorAll('.univers__tab').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    const h = tab.dataset.collection;
    if (!h) return;
    panel.classList.add('is-loading');
    try {
      if (!cache.has(h)) {
        const html = await (await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}collections/${h}?section_id=univers-panel`)).text();
        const rail = new DOMParser().parseFromString(html, 'text/html').querySelector('.univers__rail');
        cache.set(h, rail ? rail.outerHTML : '');
      }
      if (tab.getAttribute('aria-selected') === 'true') { panel.innerHTML = cache.get(h); window.Dine && Dine.scan && Dine.scan(panel); }
    } finally { panel.classList.remove('is-loading'); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
